import { render } from "./TreeFilter.vue?vue&type=template&id=6b4a544e&scoped=true"
import script from "./TreeFilter.vue?vue&type=script&lang=js"
export * from "./TreeFilter.vue?vue&type=script&lang=js"

import "./TreeFilter.vue?vue&type=style&index=0&id=6b4a544e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4a544e"]])

export default __exports__